import React from 'react';

interface Stat {
  value: string;
  label: string;
  hint?: string;
}

const stats: Stat[] = [
  { value: '320+', label: 'Curated generics', hint: 'Across 13 health categories' },
  { value: '90%', label: 'Avg savings vs US retail', hint: 'Verified against 4 competitor sites' },
  { value: '30+', label: 'Countries shipped', hint: 'Tracked end-to-end' },
  { value: '100%', label: 'Licensed sourcing', hint: 'GMP-certified only' },
];

const StatsBand: React.FC = () => (
  <section className="relative py-28 lg:py-36 overflow-hidden bg-forest-900 text-cream-50">
    <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="dot-pattern" x="0" y="0" width="24" height="24" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dot-pattern)" />
      </svg>
    </div>
    <div className="relative max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12">
      <div className="max-w-2xl mb-16 lg:mb-20">
        <p className="text-caption text-gold-300 font-medium tracking-[0.2em] uppercase mb-4">
          By the numbers
        </p>
        <h2 className="font-display text-display-sm lg:text-display-md tracking-tight leading-tight">
          Real savings. Real pharmacies. Real people.
        </h2>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
        {stats.map((s) => (
          <div key={s.label} className="border-t border-cream-50/20 pt-6">
            <div className="font-display text-display-md lg:text-display-lg text-cream-50 tracking-tight mb-3">
              {s.value}
            </div>
            <div className="text-body font-medium text-cream-50 mb-1 tracking-wide">
              {s.label}
            </div>
            {s.hint && (
              <div className="text-caption text-cream-50/60 leading-relaxed">{s.hint}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsBand;
